import React from 'react'
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react'
import { AlertsCenter } from './AlertsCenter'
import { useSidebar } from '../context/SidebarContext'

// Check if Clerk is configured
const clerkEnabled = !!(import.meta as any).env?.VITE_CLERK_PUBLISHABLE_KEY

export function SidebarUser() {
  const { isCollapsed } = useSidebar()

  if (!clerkEnabled) {
    return null
  }

  return (
    <div className="sidebar-footer">
      <div className="sidebar-user">
        <SignedIn>
          <AlertsCenter />
          {!isCollapsed && <div className="sidebar-user-info" />}
          <UserButton
            afterSignOutUrl="/"
            appearance={{
              elements: {
                avatarBox: 'clerk-avatar',
              },
            }}
          />
        </SignedIn>
        <SignedOut>
          <a href="/sign-in" className="sidebar-item" style={{ flex: 1 }}>
            <span className="sidebar-item-label">Sign In</span>
          </a>
        </SignedOut>
      </div>
    </div>
  )
}
